import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

/**
 * Hook to fetch and group enum values from lookup tables based on lookupGroup references.
 * Returns a map of lookup_group -> array of values.
 */
export function useFieldLookups(lookupGroups: string[]) {
  return useQuery({
    queryKey: ['field-lookups', ...lookupGroups.sort()],
    queryFn: async () => {
      if (lookupGroups.length === 0) return {};

      const { data, error } = await supabase
        .from('lookups')
        .select('lookup_group, value, display_name')
        .in('lookup_group', lookupGroups)
        .eq('is_active', true)
        .order('display_order');

      if (error) throw error;

      // Group by lookup_group
      return data?.reduce((acc, item) => {
        if (!acc[item.lookup_group]) acc[item.lookup_group] = [];
        acc[item.lookup_group].push(item.value);
        return acc;
      }, {} as Record<string, string[]>) || {};
    },
    enabled: lookupGroups.length > 0,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
